import styled from 'styled-components/macro';
import { getFlex } from '../../styled/styleUtils';

export const HeaderWrapper = styled.header`
  text-align: center;
`;
export const HeaderInner = styled.header`
  ${getFlex()}
  padding: 1rem 0;
  .headerLogo {
    max-width: 170px;
    img {
      max-width: 100%;
    }
  }
  nav {
    a {
      padding: 0.25rem 0.5rem;
      display: inline-block;
      border-radius: 50px;
      &:hover {
        background-color: var(--blueGray-200);
      }
    }
    .headerMenuItem {
      ${getFlex()}
      i {
        margin-right: 0.5rem;
      }
    }
  }
`;
